module.exports = __webpack_public_path__ + "img/arrow-right-orange.4830e52c.svg";